import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconWallet1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconWallet1"><Path fillRule="evenodd" clipRule="evenodd" d="M2 4H22V20H2V4ZM3.5 5.5V7H20.5V5.5H3.5ZM20.5 8.5H3.5V10H9.5V12.5H14.5V10H20.5V8.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconWallet1;
